import { render, staticRenderFns } from "./MatchUsersList.vue?vue&type=template&id=3aee8f8a"
import script from "./MatchUsersList.vue?vue&type=script&lang=js"
export * from "./MatchUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports